<template>
  <div>
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item :name="index + 1" v-for="(item, index) in listData" :key="item.name">
        <div slot="title">
          {{ item.name }}
          <el-button type="primary" size="default" style="margin-left: 50px"
            @click.stop="addData(item.platformType)">新增套餐</el-button>
        </div>

        <el-table width="100%" :data="item.data" border :header-cell-style="{ textAlign: 'center' }">
          <el-table-column prop="name" label="套餐名称" align="center"></el-table-column>
          <el-table-column prop="monthlyRentAmount" label="月租" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.monthlyRentAmount">{{
                scope.row.monthlyRentAmount + ' ' + scope.row.currencyCode
              }}</span>
              <span v-else>——</span>
            </template>
          </el-table-column>
          <el-table-column prop="annualRentAmount" label="年租" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.monthlyRentAmount">{{
                scope.row.annualRentAmount + ' ' + scope.row.currencyCode
              }}</span>
              <span v-else>——</span>
            </template>
          </el-table-column>
          <el-table-column prop="monthlyFeeRate" label="手续费" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.monthlyRentAmount">{{ scope.row.monthlyFeeRate + '%' }}</span>
              <span v-else>——</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" @click="updateData(scope.row, item.platformType)">设置</el-button>
              <el-button type="danger" @click="delData(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>

    <el-dialog title="套餐设置" width="22%" :visible.sync="setVisible" @close="close">
      <el-form :model="formData" label-width="110px" :rules="rules" ref="ruleForm">
        <el-form-item label="套餐名称" prop="name">
          <el-input v-model="formData.name" style="width: 72%"></el-input>
        </el-form-item>
        <el-form-item label="是否为试用期" prop="isprobation">
          <el-select v-model="formData.isprobation" filterable>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="formData.isprobation == 1">
          <el-form-item label="免费天数" prop="freeDays">
            <el-input-number v-model="formData.freeDays" size="small" :min="0" :step="1"></el-input-number>
            天
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="月租" prop="monthlyRentAmount">
            <el-input-number v-model="formData.monthlyRentAmount" size="mini" :min="0" :controls="true"
              controls-position="both">
            </el-input-number>
            <el-select v-model="formData.currencyCode" placeholder="币种" filterable
              style="margin-left: 10px; width: 120px">
              <el-option v-for="item in exchangeRateList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年租" prop="annualRentAmount">
            <el-input-number v-model="formData.annualRentAmount" size="mini" :min="0" :controls="true"
              controls-position="both">
            </el-input-number>
            <el-select v-model="formData.currencyCode" placeholder="币种" filterable
              style="margin-left: 10px; width: 120px">
              <el-option v-for="item in exchangeRateList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手续费" prop="monthlyFeeRate">
            <el-input-number v-model="formData.monthlyFeeRate" size="mini" :min="0" :step="1"></el-input-number>
            %
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="setVisible = false">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submit('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
  name: 'IndependentStationComboRentImport',
  data() {
    return {
      activeName: 1,
      listData: [],
      setVisible: false,
      formData: { isprobation: 0 },
      userInfo: {},
      exchangeRateList: [],
      currentPlatformType: '',
      btnLoading: false,
      rules: {
        name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
        isprobation: [{ required: true, message: "请选择套餐类型", trigger: "change" }],
        freeDays: [{ required: true, message: "请输入免费天数", trigger: "blur" }],
        monthlyRentAmount: [{ required: true, message: "请输入月租金额", trigger: "blur" }],
        currencycode: [{ required: true, message: "请选择币种", trigger: "change" }],
        annualRentAmount: [{ required: true, message: "请输入年租金额", trigger: "blur" }],
        monthlyFeeRate: [{ required: true, message: "请输入年手续费", trigger: "blur" }],
      }
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("role"));
    this.getListData()
    this.getExchangeRateList()
  },
  methods: {
    // 获取汇率列表
    getExchangeRateList() {
      ajaxPost(Baseurl + 'rateController/getRatecurrencyCodeList').then((res) => {
        const { data: responseData } = res
        if (responseData.code === 200) {
          const { data } = responseData
          this.exchangeRateList = data
        }
      })
    },
    getListData() {
      this.listData = []
      ajaxPost(Baseurl + 'standalonePackageSettingsController/selectStandalonePackageSettingsList', { companyId: this.userInfo.company_id }).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data) {
            for (let key in res.data.data) {
              let platform = key.split('-')
              this.listData.push({
                platformType: platform[1],
                name: platform[0] + ' 套餐设置',
                data: res.data.data[key]
              })
            }
          }
        }
        this.loading = false
      })
    },
    addData(platformType) {
      this.currentPlatformType = platformType
      this.setVisible = true
    },
    updateData(row, platformType) {
      this.currentPlatformType = platformType
      this.formData = JSON.parse(JSON.stringify(row))
      this.setVisible = true
    },
    submit(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (this.formData.id) {
            let obj = {
              ...this.formData,
              platformType: Number(this.currentPlatformType),
              companyId: this.userInfo.company_id
            }
            this.btnLoading = true
            ajaxPost(Baseurl + 'standalonePackageSettingsController/updateStandalonePackageSettings', obj).then(() => {
              this.getListData()
              this.btnLoading = false
              this.close()
              this.$message.success('修改成功')
            }).catch(() => {
              this.btnLoading = false
              this.$message.error('服务器出错，请联系客服')
            })
          } else {
            let obj = {
              ...this.formData,
              platformType: Number(this.currentPlatformType),
              companyId: this.userInfo.company_id
            }
            this.btnLoading = true
            ajaxPost(Baseurl + 'standalonePackageSettingsController/insertStandalonePackageSettings', obj).then(() => {
              this.getListData()
              this.btnLoading = false
              this.close()
              this.$message.success('新增成功')
            }).catch(() => {
              this.btnLoading = false
              this.$message.error('服务器出错，请联系客服')
            })
          }
        }
      })
    },
    close() {
      this.formData = { isprobation: 0 }
      this.currentPlatformType = ''
      this.setVisible = false
    },
    delData(id) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ajaxPost(Baseurl + "standalonePackageSettingsController/deleteStandalonePackageSettings", {id}).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getListData();
          } else {
            this.$message.error(res.data.data)
          }
        })
      })
    }
  }
}
</script>